export default {"background":"caution-icon-module__background___nkxNc","icon":"caution-icon-module__icon___ODnkB","outline":"caution-icon-module__outline___AE-Se"}
import '/home/jenkins/agent/workspace/elease_release_common-icons_5.12/packages/common/icons/src/components/icons/caution-icon.module.css'
